import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from '../contexts/LanguageContext';

const Home: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section id="home" className="hero text-center">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} xl={7}>
            <p className="kicker">{t('home.subtitle')}</p>
            <h1 className="hero-title">{t('home.title')}</h1>
            <p className="hero-lead">{t('home.tagline')}</p>
            <div className="hero-actions">
              <a href="#contact" className="btn-solid">{t('home.contactMe')}</a>
              <a href="#about" className="btn-ghost">{t('home.learnMore')}</a>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Home;
